import trackingEvents from './_trackingEvents';

const eventName = trackingEvents.ELEMENT_TAPPED;

/*
<a href="https://xxxx">CLICK ME</a>
<div data-track-element-tapped="ELEMENT-NAME" data-destination="any string">CLICK ME</div>

ELEMENT-ITEM 命名規則（設定がない場合はHTMLタグ名になります）

e.g. HERO__EARLY-BIRD

- すべて大文字
- ネストは関係は __ で表現
- 単語繋ぎは - で表現

NOTE: どんな感じで運用されるか固まっていないので定数として定義していません
*/

export default function trackElementTapped(element, customName = null) {
  const elementName = element.getAttribute('data-track-element-tapped');
  const destination = element.getAttribute('data-destination');

  const properties = {
    // default: HTML tag name
    element: customName ? customName : ( elementName ? elementName : element.tagName ),
    // default: href value
    destination: destination,
  };

  if (!properties.destination) {
    properties.destination = element.getAttribute('href');
  }
  if (elementName != null) {
    window.gtag('event', `${eventName} ${properties.element}`, {
      event_label: `${eventName} ${properties.element}`,
    });
  }
}
